export const sortByStringAttribute =
  <T extends Partial<Record<K, any>>, K extends PropertyKey>(fieldName: K) =>
  (items?: T[]): T[] =>
    items?.sort((a, b) => {
      const string_a = a[fieldName] || '';
      const string_b = b[fieldName] || '';

      if (string_a < string_b) {
        return -1;
      }

      if (string_a > string_b) {
        return 1;
      }

      return 0;
    }) || [];

export const sortByName = sortByStringAttribute('name');
export const sortByTitle = sortByStringAttribute('title');
export const sortByType = sortByStringAttribute('type');
export const sortByLabel = sortByStringAttribute('label');

/** Takes a list a predicate. Items matching predicate will be moved to the end of the list */
export function sortMatchingToEnd<T>(
  predicate: (item: T) => boolean
): (arr: T[]) => T[] {
  return (arr: T[]) => {
    const matchingItems = arr.filter(predicate); // Get matching items
    const nonMatchingItems = arr.filter((item) => !predicate(item)); // Get non-matching items
    return [...nonMatchingItems, ...matchingItems]; // Combine the arrays and return
  };
}
